import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DimonaAdmin } from 'src/app/admin/model/dimonaAdmin.model';
import { FacadeService } from 'src/app/shared/service/facade/facade.service';

@Component({
  selector: 'app-dimona-dialog',
  templateUrl: './dimona-dialog.component.html',
  styleUrls: ['./dimona-dialog.component.css']
})
export class DimonaDialogComponent implements OnInit {

  dimonaAdmin: DimonaAdmin;
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DimonaDialogComponent>,
    private facade: FacadeService,
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {
    this.dimonaAdmin = this.data.element;
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({
      dimonaId: [(this.dimonaAdmin.dimonaId !== null && this.dimonaAdmin.dimonaId !== undefined) ? this.dimonaAdmin.dimonaId : null, []],
      periodId: [(this.dimonaAdmin.periodId !== null && this.dimonaAdmin.periodId !== undefined) ? this.dimonaAdmin.periodId : null, []],
      dimonaType: [(this.dimonaAdmin.dimonaType !== null && this.dimonaAdmin.dimonaType !== undefined) ? this.dimonaAdmin.dimonaType : "", []],
      dimonaStatus: [(this.dimonaAdmin.dimonaStatus !== null && this.dimonaAdmin.dimonaStatus !== undefined) ? this.dimonaAdmin.dimonaStatus : "", []],
      startDate: [(this.dimonaAdmin.startDate !== null && this.dimonaAdmin.startDate !== undefined) ? this.dimonaAdmin.startDate : "", []],
      endDate: [(this.dimonaAdmin.endDate !== null && this.dimonaAdmin.endDate !== undefined) ? this.dimonaAdmin.endDate : "", []],
      dimonaPeriodId: [(this.dimonaAdmin.dimonaPeriodId !== null && this.dimonaAdmin.dimonaPeriodId !== undefined) ? this.dimonaAdmin.dimonaPeriodId : "", [Validators.required]],
      reference: [(this.dimonaAdmin.reference !== null && this.dimonaAdmin.reference !== undefined) ? this.dimonaAdmin.reference : "", []],
    });
  }

  onSubmit() {
    Object.assign(this.dimonaAdmin, this.form.value);
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.getFormValidationErrors(this.form);
      return this.openSnackBar(this.translate.instant('popup.form-invalid'), 'X', 'customSnackError');
    }

    this.facade.updateWithDimonaAdmin(this.dimonaAdmin)
      .subscribe({
        next: dimonaAdmin => {
          this.openSnackBar(this.translate.instant('popup.save-success-simple'), 'X', 'customSnackValid');
        },
        error: (error: HttpErrorResponse) => {
          this.openSnackBar(
            this.translate.instant('popup.save-error', { error: error.message }),
            'X', 'customSnackError');
        }
      });
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string, pC: string) {
    this.snackBar.open(message, action, {
      duration: 10000,
      panelClass: [pC]
    });
  }

  private getFormValidationErrors(form: FormGroup) {
    Object.keys(form.controls).forEach(key => {
      if (form.get(key) instanceof FormGroup) {
        this.getFormValidationErrors(form.get(key) as FormGroup);
      }
    });
  }

  cancel(): void {
    this.form.reset();
    this.dialogRef.close();
  }
}
